import React from 'react'
import IsLoggedinHOC from '../../Components/IsLoggedinHOC';
import AggregatorBar from '../../Components/Chart/AggregatorBar';

function AggregatorOrdersCharts() {
    return (
        <div className="content-wrapper">
            <div className="content-header main_breadcrumb_top">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Aggregator's Orders Count</h1>
                        </div>
                        <div className="col-sm-6">
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <AggregatorBar />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default IsLoggedinHOC(AggregatorOrdersCharts)
